export enum SystemFolderId {
  SiteFiles = 'media-root',
  Mobile = 'mobile-uploads',
  Purchased = 'purchased-items',
  VisitorUploads = 'visitor-uploads',
  AllWixMedia = '{"siteMediaToken":null,"id":null}',
  WixSites = 'wix-sites',
  Trash = 'trash-root',
  Boards = 'boards',
  WixVideoLink = 'wix-video-library-link',
}
